/*
 * Module for the Rollover Type step of the DROP Distribution Election form
*/
rs.module("ui/content/communications/onlineforms/rollovertype",

    [
        "common/select-helper",
        "controls/components/event-banner",
        "common/visibility"
    ],

    function (selectHelper, eventBanner, visibility) {
        // Initialize the module
        function initialize(jsSelectors) {

            var stepContainer = $.js(jsSelectors.stepContainer);
            var rolloverTypeRadio = stepContainer.js(jsSelectors.rolloverTypeRadio, { multiple: true });
            var rolloverTypeDescriptionDiv = stepContainer.js(jsSelectors.rolloverTypeDescriptionDiv, { multiple: true });

            var selected = rolloverTypeRadio.filter(":checked");
            var selectedIndex = rolloverTypeRadio.index(selected);
            if (selectedIndex !== null && selectedIndex >= 0) {
                showSelectedRolloverTypeDescription(selectedIndex);
            }

            // Handle the rolloverTypeRadio click event
            rolloverTypeRadio.on("click", function () {

                var selectedIndex = rolloverTypeRadio.index(this);
                showSelectedRolloverTypeDescription(selectedIndex);
            });

            // Show (slide down) the description for the selected rollover type
            function showSelectedRolloverTypeDescription(selectedIndex) {

                // Close all quickly
                rolloverTypeDescriptionDiv.stop(true, true).slideUp(150);

                // Open the selected one
                rolloverTypeDescriptionDiv.eq(selectedIndex).stop(true, true).slideDown(150);
            }
        }

        // Exported public API
        var exports = {
            initialize: initialize
        };

        return exports;
    }
);